import { generatePath } from './generate-path';
// Use this to directly generate a path for any route that exists in the config
export const generateReactRouterPath = (...args) => `${generatePath(args)}`;
